module.exports = __webpack_public_path__ + "img/send-template.554342bc.png";